import type { SearchApiParams } from "../../../types/search";

/**
 * Shared query key for homePinsAtom and the /search SSR loader.
 * Both must produce the same key byte-for-byte for cache warmth to work.
 *
 * If homePinsAtom's queryFn post-processing changes (new computed fields,
 * fallback removal in VenueCard), the SSR-warmed /search view may display
 * incorrectly. Re-audit when modifying either file.
 */
export function homePinsQueryKey(
  params: SearchApiParams,
  accessToken: string | null | undefined,
) {
  return ["homePins", params, accessToken] as const;
}
